import { useAuth } from '../../../hooks/useAuth';
import { useFirebase } from '../../../hooks/useFirebase';

import { queryGet } from '../../tools/tools';
import { useEndpoint } from '../endpoint/useEndpoint';
import { useQuery } from '@tanstack/react-query';

export const useMenuCategories = () => {
  const { user } = useAuth();
  const { remoteConfig } = useFirebase();
  const menuCategoriesQuery = useEndpoint('/menu/categories', 'menuCategories');

  const {
    data: icons,
    isLoading: isIconsLoading,
    isError: isIconsError,
    refetch: refetchIcons
  } = useQuery({
    queryKey: ['menuCategoryIcons'],
    queryFn: async () => await queryGet(remoteConfig, '/menu/categories/icons'),
    enabled: !!user?.accessToken && !!remoteConfig
  });

  return {
    ...menuCategoriesQuery,
    loading: menuCategoriesQuery.loading || isIconsLoading,
    error: menuCategoriesQuery.error || isIconsError,
    refetchIcons,
    icons
  };
};
